import { render, staticRenderFns } from "./ModattaStepBrand.vue?vue&type=template&id=92b2b4da"
import script from "./ModattaStepBrand.vue?vue&type=script&lang=js"
export * from "./ModattaStepBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports